/**
 * Internal dependencies
 */
import SVGCurve1 from './images/curve-1.svg'
import SVGCurve1Inverted from './images/curve-1-inverted.svg'
import SVGCurve2 from './images/curve-2.svg'
import SVGCurve2Inverted from './images/curve-2-inverted.svg'
import SVGCurve3 from './images/curve-3.svg'
import SVGCurve3Inverted from './images/curve-3-inverted.svg'
import SVGRounded1 from './images/rounded-1.svg'
import SVGRounded1Inverted from './images/rounded-1-inverted.svg'
import SVGRounded2 from './images/rounded-2.svg'
import SVGRounded2Inverted from './images/rounded-2-inverted.svg'
import SVGRounded3 from './images/rounded-3.svg'
import SVGRounded3Inverted from './images/rounded-3-inverted.svg'
import SVGSlant1 from './images/slant-1.svg'
import SVGSlant1Inverted from './images/slant-1-inverted.svg'
import SVGSlant2 from './images/slant-2.svg'
import SVGSlant2Inverted from './images/slant-2-inverted.svg'
import SVGStraight1 from './images/straight-1.svg'
import SVGWave1 from './images/wave-1.svg'
import SVGWave1Inverted from './images/wave-1-inverted.svg'
import SVGWave2 from './images/wave-2.svg'
import SVGWave2Inverted from './images/wave-2-inverted.svg'
import SVGWave3 from './images/wave-3.svg'
import SVGWave3Inverted from './images/wave-3-inverted.svg'
import SVGWave4 from './images/wave-4.svg'
import SVGWave4Inverted from './images/wave-4-inverted.svg'

export const separators = {
	'wave-1': {
		default: {
			shape: SVGWave1,
		},
		inverted: {
			shape: SVGWave1Inverted,
		},
	},
	'wave-2': {
		default: {
			shape: SVGWave2,
		},
		inverted: {
			shape: SVGWave2Inverted,
		},
	},
	'wave-3': {
		default: {
			shape: SVGWave3,
		},
		inverted: {
			shape: SVGWave3Inverted,
		},
	},
	'wave-4': {
		default: {
			shape: SVGWave4,
		},
		inverted: {
			shape: SVGWave4Inverted,
		},
	},
	'curve-1': {
		default: {
			shape: SVGCurve1,
		},
		inverted: {
			shape: SVGCurve1Inverted,
		},
	},
	'curve-2': {
		default: {
			shape: SVGCurve2,
		},
		inverted: {
			shape: SVGCurve2Inverted,
		},
	},
	'curve-3': {
		default: {
			shape: SVGCurve3,
		},
		inverted: {
			shape: SVGCurve3Inverted,
		},
	},
	'slant-1': {
		default: {
			shape: SVGSlant1,
		},
		inverted: {
			shape: SVGSlant1Inverted,
		},
	},
	'slant-2': {
		default: {
			shape: SVGSlant2,
		},
		inverted: {
			shape: SVGSlant2Inverted,
		},
	},
	'straight-1': {
		default: {
			shape: SVGStraight1,
		},
		inverted: {
			shape: SVGStraight1,
		},
	},
	'rounded-1': {
		default: {
			shape: SVGRounded1,
		},
		inverted: {
			shape: SVGRounded1Inverted,
		},
	},
	'rounded-2': {
		default: {
			shape: SVGRounded2,
		},
		inverted: {
			shape: SVGRounded2Inverted,
		},
	},
	'rounded-3': {
		default: {
			shape: SVGRounded3,
		},
		inverted: {
			shape: SVGRounded3Inverted,
		},
	},
}
